import { ref } from "vue";

const currentTool = ref("");
const currentColor = ref("#000");
const currentSize = ref(1);
const isConfirmClear = ref(false);
const isNoteOpen = ref(false);
const isLocked = ref(false);
const modes = [
    "stacked-video",
    "stacked-play",
    "floating-play",
    "floating-video",
    "video-fullscreen",
    "play-fullscreen",
];
const preview = ref({
    mode: "play-fullscreen",
});

const animation = ref({
    active: false,
    currentFrame: 1,
    frames: {},
    playing: false,
    showLines: true,
    playerSpeeds: {},
    selectedPlayerId: null,
    selectedPlayerLabel: "",
    selectedPlayerSpeed: 1,
    hasBall: false,
    camera3d: false,
    cameraPreset: "bird",
});

export default function useWhiteboard() {
    return {
        currentTool,
        currentColor,
        currentSize,
        isConfirmClear,
        isNoteOpen,
        isLocked,
        modes,
        preview,
        animation,
    };
}
